import {
  JackpotCommandObj,
  JackpotWebsocketEnhanced
} from 'interfaces/spring-websocket-interfaces';
import { connectingJackpotWS } from 'hooks/useJackpotConnect';

export const sendJackpotCommand = (
  rid: string,
  data: JackpotCommandObj,
  callback: Function,
  errorCallBack?: Function
): void => {
  connectingJackpotWS.then((socket: JackpotWebsocketEnhanced) =>
    socket.sendCommand(
      data,
      rid,
      callback,
      () => undefined,
      errorCallBack ?? null
    )
  );
};

export const unsubscribeCommand = (rid: string): void => {
  connectingJackpotWS.then((socket: JackpotWebsocketEnhanced) =>
    socket.unsubscribe(rid)
  );
};

export const unsubscribeAllCommand = (rids: Array<string>): void => {
  connectingJackpotWS.then((socket: JackpotWebsocketEnhanced) => {
    socket.unsubscribeAll(rids);
  });
};
